import config from 'config'

export const IA_HOST_NAME = config.iaHostName
export const DYNAMIC_URL = config.functionsURL
export const SHOPIFY_POPUP = `${DYNAMIC_URL}/proto?actionType=popup_shopify`
export const SUBSCRIPTION_URL = `${DYNAMIC_URL}/proto?actionType=subscribe`
export const SCRAP_URL = `${DYNAMIC_URL}/proto?actionType=scrap`
export const SHOPIFY_ACTIVATE_URL = `${DYNAMIC_URL}/proto?actionType=shopfyAddToWebsite`
export const SHOPIFY_ASSETS_URL = `${DYNAMIC_URL}/proto?actionType=shopifyAssets`
export const SHOPIFY_COLLECTION_PRODUCTS_URL = `${DYNAMIC_URL}/proto?actionType=shopifyProductsByCollection`
export const SHOPIFY_RECURRING_CHARGE_CREATE = `${DYNAMIC_URL}/proto?actionType=createRecurringApplicationCharge`
export const SHOPIFY_COLLECTIONS_BY_PRODUCT_URL = `${DYNAMIC_URL}/proto?actionType=shopifyCollectionsByProduct`
export const SHOPIFY_PREVIEW_SMS_URL = `${DYNAMIC_URL}/proto?actionType=sendPreviewSms`
export const SHOPIFY_ADD_WEBHOOK_URL = `${DYNAMIC_URL}/proto?actionType=addWebhook`
export const SHOPIFY_APP_UNINSTALLED_URL = `${DYNAMIC_URL}/proto?actionType=appUninstalled`
export const SHOPIFY_APP_ORDER_EVENT_URL = `${DYNAMIC_URL}/proto?actionType=orderEvent`
export const SHOPIFY_APP_ORDERS_URL = `${DYNAMIC_URL}/proto?actionType=shopifyOrders`



// WEBPACK FOOTER //
// ./src/constants/index.js